import axios from 'axios';
import User from './User';

class AxiosAPI {
  constructor() {
    this.base_url = `${process.env.LUMINARY_API_HOST}/v1`;
  }

  setDefaultHeader(name, value) {
    axios.defaults.headers.common[name] = value;
  }

  getList(endpoint, params) {
    const url = `${this.base_url}/${endpoint}`;
    const config = {};

    config.params = params;
    return axios.get(url, config).then(resp => resp.data);
  }

  async get(endpoint, id, params, isFullURL = false) {
    let url = !id ? `${this.base_url}/${endpoint}` : `${this.base_url}/${endpoint}/${id}`;
    if (isFullURL) {
      url = endpoint;
    }
    const config = {};
    config.params = params;

    const userProvider = new User();
    const token = await userProvider.getUserToken();
    userProvider.setUserToken(token);
    // config.headers.common['X-Id-Token'] = token;
    return axios.get(url, { headers: { 'X-Id-Token': token } }).then(resp => resp.data);
  }

  post(endpoint, data, headers) {
    const url = `${this.base_url}/${endpoint}`;
    const config = {};
    if (headers) {
      config.headers = headers;
    }
    return axios.post(url, data, config).then(resp => resp.data);
  }

  put(endpoint, id, data) {
    const url = !id ? `${this.base_url}/${endpoint}` : `${this.base_url}/${endpoint}/${id}`;
    const config = {};
    return axios.put(url, data, config).then(resp => resp.data);
  }

  delete(endpoint, id) {
    let url = `${this.base_url}/${endpoint}`;
    if (id) {
      url = `${url}/${id}`;
    }
    const config = {};
    return axios.delete(url, config);
  }
}

export default AxiosAPI;



// WEBPACK FOOTER //
// ./app/src/services/AxiosAPI.js